import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=1743ab91&"
import script from "./MainCarousel.vue?vue&type=script&lang=js&"
export * from "./MainCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports